import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import ScrollToTop from "@/components/ScrollToTop";
import EventSchema from "@/components/EventSchema";
import Home from "@/pages/Home";
import TheArtist from "@/pages/TheArtist";
import Work from "@/pages/Work";
import Exhibitions from "@/pages/Exhibitions";
import Press from "@/pages/Press";
import PressRelease from "@/pages/PressRelease";
import MediaKit from "@/pages/MediaKit";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import ChapterII from "@/pages/ChapterII";
import Success from "@/pages/Success";
import Collector from "@/pages/Collector";
import Admin from "@/pages/Admin";
import Campaign from "@/pages/Campaign";
import ArchiveProspectus from "@/pages/ArchiveProspectus";
import The190 from "@/pages/The190";

const isThe190Domain = window.location.hostname.startsWith("the190.");

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <EventSchema />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#121212",
              color: "#f7f5f0",
              border: "1px solid rgba(247,245,240,0.12)",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
              fontWeight: 300,
              letterSpacing: "0.04em",
            },
          }}
        />
        <Routes>
          <Route path="/" element={isThe190Domain ? <The190 /> : <Home />} />
          <Route path="/the-artist" element={<TheArtist />} />
          <Route path="/work" element={<Work />} />
          <Route path="/exhibitions" element={<Exhibitions />} />
          <Route path="/press" element={<Press />} />
          <Route path="/press-release" element={<PressRelease />} />
          <Route path="/media-kit" element={<MediaKit />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/chapter-ii" element={<ChapterII />} />
          <Route path="/success" element={<Success />} />
          <Route path="/collector" element={<Collector />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/campaign" element={<Campaign />} />
          <Route path="/archive-prospectus" element={<ArchiveProspectus />} />
          <Route path="/collector-editions" element={<The190 />} />
          <Route path="/the-190" element={<Navigate to="/collector-editions" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
